"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAdvertisingMachineAdsRoute = exports.ROUTE_ADVERTISING_MACHINE_ADS = exports.ROUTE_ADVERTISING_LIST = exports.ROUTE_SETTLEMENT_DETAIL = exports.ROUTE_SETTLEMENT_LIST = exports.ROUTE_BILLING_DETAIL = exports.ROUTE_BILLING_LIST = exports.ROUTE_INVOICE = exports.ROUTE_ORDER_DETAIL = exports.ROUTE_ORDERS_LIST = exports.ROUTE_REFILLS_DETAIL = exports.ROUTE_REFILLS_LIST = exports.ROUTE_PRODUCTS_EDIT = exports.ROUTE_PRODUCTS_CREATE = exports.ROUTE_PRODUCTS_LIST = exports.ROUTE_MOBILE_PROFILE = exports.ROUTE_MACHINE_CONFIG = exports.ROUTE_MACHINE_DETAIL = exports.ROUTE_MACHINE_LIST = exports.ROUTE_HOME = exports.ROUTE_BASE = void 0;
exports.ROUTE_BASE = '/app';
exports.ROUTE_HOME = '/';
exports.ROUTE_MACHINE_LIST = '/machines/list';
exports.ROUTE_MACHINE_DETAIL = '/machines/:id';
exports.ROUTE_MACHINE_CONFIG = '/machines/:id/configuration';
exports.ROUTE_MOBILE_PROFILE = '/mobile/profile';
exports.ROUTE_PRODUCTS_LIST = '/products/list';
exports.ROUTE_PRODUCTS_CREATE = '/products/create';
exports.ROUTE_PRODUCTS_EDIT = '/products/:id';
exports.ROUTE_REFILLS_LIST = '/refills/list';
exports.ROUTE_REFILLS_DETAIL = '/refills/:id';
exports.ROUTE_ORDERS_LIST = '/orders/list';
exports.ROUTE_ORDER_DETAIL = '/orders/:id';
exports.ROUTE_INVOICE = '/invoices/:id';
exports.ROUTE_BILLING_LIST = '/billing/list';
exports.ROUTE_BILLING_DETAIL = '/billing/:id';
exports.ROUTE_SETTLEMENT_LIST = '/settlement/list';
exports.ROUTE_SETTLEMENT_DETAIL = '/settlement/:id';
exports.ROUTE_ADVERTISING_LIST = '/advertising/list';
exports.ROUTE_ADVERTISING_MACHINE_ADS = '/advertising/machines/:machineId/ads';
const buildAdvertisingMachineAdsRoute = (machineId) => `/advertising/machines/${machineId}/ads`;
exports.buildAdvertisingMachineAdsRoute = buildAdvertisingMachineAdsRoute;
